import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  container: {
    px: 3,
    py: 2,
  },
  sectionHeader: {
    mb: 2,
  },
  subsectionTitle: {
    fontWeight: theme.typography.fontWeightBold,
    mb: 1,
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    mb: theme.spacing(1),
  },
  validationContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  addButton: {
    fontSize: theme.typography.body2.fontSize,
    mb: theme.spacing(2),
  },
});
